import { render, staticRenderFns } from "./TrademarkType.vue?vue&type=template&id=f68977ac&"
import script from "./TrademarkType.vue?vue&type=script&lang=js&"
export * from "./TrademarkType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports